<template>
  <div class="variable-creator">
    <h3>{{ $t("extra-variables.create-title") }}</h3>
    <div class="form-group">
      <label for="varType">{{ $t("extra-variables.type-label") }}</label>
      <select v-model="selectedType" name="varType" id="varType" class="form-control selector">
        <option value="option1">Standard</option>
        <option value="option2">{{ $t("extra-variables.if") }}</option>
        <option value="option3">{{ $t("extra-variables.dictionary") }}</option>
        <option value="option4">List {{ $t("extra-variables.dictionary") }}</option>
      </select>
    </div>

    <!-- for pathfinder -->
    <!-- <button class="btn btn-secondary" @click="$emit('get-variable-groups'), stagedInputField = 'path'" type="button">{{dictionary.expression ? dictionary.expression.substring(1, dictionary.expression.length -1 )  : 'Path'}}</button>
            <custom-input :class="stagedInputField == 'path' ?'active-input' : ''" :inputType="'text'" v-model="variablePath" :name="'extraVariablePath'" :label="'Sti'" :placeholder="'Sti'" :optionBtn="true" :btnText="'Find sti'" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'path'"/> -->

    <form @submit.stop.prevent="exportExtraVariable" v-if="selectedType == 'option1' || selectedType == 'option2'">
      <custom-input
        :inputType="'text'"
        v-model="extraVariable.name"
        :name="'exraVariableName'"
        :label="$t('extra-variables.name')"
        :placeholder="$t('extra-variables.var-name-placeholder')"
        :focusInputField="true"
        :invalidInput="invalid || invalidName"
      />
      <span v-if="invalid" class="text-danger small">{{ $t("extra-variables.error-txt") }}</span>
      <custom-input
        :class="stagedInputField == 'expression' ? 'active-input' : ''"
        v-if="selectedType == 'option1'"
        :inputType="'text'"
        v-model="extraVariable.expression"
        :name="'exraVariableExpression'"
        :label="$t('extra-variables.expression')"
        :placeholder="$t('extra-variables.expression-placeholder')"
        :optionBtn="true"
        :btnText="$t('extra-variables.add-var-btn')"
        @option-btn-clicked="$emit('get-variable-groups'), (stagedInputField = 'expression')"
      />

      <div v-if="selectedType == 'option2'">
        <div v-for="(ifThenInstance, index) in ifThen.ifThenList" :key="index">
          <custom-input
            :class="stagedInputField == 'if' ? 'active-input' : ''"
            :inputType="'text'"
            v-model="ifThen.ifThenList[index].ifCondition"
            :name="'exraVariableIfStatement' + index"
            :label="$t('extra-variables.if')"
            :placeholder="$t('extra-variables.if')"
            :optionBtn="true"
            :btnText="$t('extra-variables.add-var-btn')"
            @option-btn-clicked="
              $emit('get-variable-groups'),
                (stagedInputField = {
                  name: 'ifCondition',
                  index: index,
                })
            "
          />
          <custom-input
            :class="stagedInputField == 'then' ? 'active-input' : ''"
            :inputType="'text'"
            v-model="ifThen.ifThenList[index].then"
            :name="'exraVariableThenStatement' + index"
            :label="$t('extra-variables.then')"
            :placeholder="$t('extra-variables.then')"
            :optionBtn="true"
            :btnText="$t('extra-variables.add-var-btn')"
            @option-btn-clicked="
              $emit('get-variable-groups'),
                (stagedInputField = {
                  name: 'then',
                  index: index,
                })
            "
          />
          <div v-if="ifThen.ifThenList.length > 1" class="btn btn-xs" @click="removeIfInstance(index)">
            - Remove
          </div>
        </div>
        <div class="btn btn-xs" @click="newIfInstance">+ If</div>

        <custom-input
          :class="stagedInputField == 'else' ? 'active-input' : ''"
          :inputType="'text'"
          v-model="extraVariable.else"
          :name="'exraVariableElseStatement'"
          :label="$t('extra-variables.else')"
          :placeholder="$t('extra-variables.else-placeholder')"
          :optionBtn="true"
          :btnText="$t('extra-variables.add-var-btn')"
          @option-btn-clicked="$emit('get-variable-groups'), (stagedInputField = 'else')"
        />
      </div>

      <div class="form-group" v-if="selectedType == 'option1' || selectedType == 'option2'">
        <label for="formatType" :class="{ hide: !extraVariable.type }" style="margin-bottom: 0; margin-top: 10px"
          >Output type</label
        >
        <select name="formatType" class="form-control selector" v-model="extraVariable.type" required>
          <option disabled value="">Output type</option>
          <option value="Text">{{ $t("extra-variables.text") }}</option>
          <option value="Number">{{ $t("extra-variables.number") }}</option>
          <option value="List">{{ $t("extra-variables.list") }}</option>
          <option value="Boolean">{{ $t("extra-variables.bool") }}</option>
          <option value="Date">{{ $t("extra-variables.date") }}</option>
          <option value="Timespan">{{ $t("extra-variables.timespan") }}</option>
        </select>
      </div>
      <div class="actions">
        <button
          type="button"
          v-if="selectedType"
          :disabled="!valid || invalidName"
          @click="exportExtraVariable"
          class="btn btn-primary"
        >
          {{ $t("extra-variables.create") }}
        </button>
      </div>
    </form>
    <div class="dictionary" v-if="selectedType == 'option3' || selectedType == 'option4'">
      <form @submit.stop.prevent>
        <custom-input
          :inputType="'text'"
          v-model="dictionary.name"
          :name="'dictionaryName'"
          :label="$t('extra-variables.name')"
          :placeholder="$t('extra-variables.var-name-placeholder')"
          :focusInputField="true"
          :invalidInput="invalid || invalidName"
        />
        <span v-if="invalid" class="text-danger small">{{ $t("extra-variables.error-txt") }}</span>
        <div class="form-group dictionary-group">
          <label>{{ selectedType == "option4" ? "List" : $t("extra-variables.variable") }}</label>
          <button
            class="btn btn-secondary"
            @click="
              $emit('get-variable-groups', selectedType == 'option4' ? ['List'] : null),
                (stagedInputField = 'expression')
            "
            type="button"
          >
            {{
              dictionary.expression
                ? dictionary.expression.substring(1, dictionary.expression.length - 1)
                : $t("extra-variables.add-var-btn")
            }}
          </button>
        </div>

        <dictionary-adder :mappings="mappings" :focusInput="false" />

        <div class="mappings">
          <div class="mapping" v-for="(map, index) in mappings" :key="index">
            <div class="row">
              <custom-input
                class="col-lg-5 arrow"
                :inputType="'text'"
                v-model="map.string"
                :name="`mapString${index}`"
                :label="'String'"
              />
              <custom-input
                class="col-lg-6"
                :inputType="'text'"
                v-model="map.expression"
                :name="`mapExpression${index}`"
                :label="'Expression'"
              />
              <button type="button" class="btn col-lg-1" @click="removeMapping(map, index)">
                <img src="@/assets/svg/trash-button-no-circle.svg" />
              </button>
            </div>
          </div>
        </div>
        <div class="advanced-options">
          <div class="advanced-options-header text-xs" @click="advancedIsOpen = !advancedIsOpen">
            <span>Advanced</span>
            <div :class="{ 'flip-chevron': advancedIsOpen }">
              <i class="fa-light fa-chevron-down"></i>
            </div>
          </div>
          <div v-if="advancedIsOpen">
            <custom-input
              :focusInputField="true"
              :inputType="'text'"
              v-model="dictionary.dictionaryInputFormat"
              :name="'dictionaryInputFormat'"
              :label="'Input format'"
              :placeholder="'Type a format for the input'"
            />
            <custom-input
              :inputType="'text'"
              v-model="dictionary.dictionaryOutputExpression"
              :name="'dictionaryOutputExpression'"
              :label="'Output expression'"
              :placeholder="'Type an expression for the output'"
            />
          </div>
        </div>
        <div class="actions">
          <button
            type="button"
            v-if="selectedType"
            :disabled="!valid || invalidName"
            @click="exportExtraVariable"
            class="btn btn-primary"
          >
            {{ $t("extra-variables.create") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import VariableHelpers from "@/assets/js/variableHelpers";
import CustomInput from "@/components/CustomInput";
import CustomPopover from "@/components/CustomPopover";
import EditExtraVariable from "@/components/EditExtraVariable";
import VariableSelector from "@/components/VariableSelector";
import DictionaryAdder from "@/components/DictionaryAdder";
import EventBus from "@/assets/js/eventBus.js";
export default {
  name: "createExtraVariable",
  props: {
    extraVariables: Array,
  },
  data() {
    return {
      extraVariable: {
        name: "",
        expression: "",
        type: "",
        if: "",
        then: "",
        elseIf: "",
        elseIfThen: "",
        else: "",
      },
      standard: {
        name: "",
        expression: "",
        type: "",
      },
      ifThen: {
        name: "",
        type: "",
        ifThenList: [
          {
            ifCondition: "",
            then: "",
          },
        ],
        else: "",
      },
      dictionary: {
        name: "",
        expression: "",
        mappings: {},
        else: "",
        dictionaryInputFormat: "",
        dictionaryOutputExpression: "",
      },
      mappings: [],
      selectedType: "option1",
      invalid: false,
      elseIfLevel: false,
      elseAnimation: false,
      stagedInputField: null,
      variablePath: "",
      advancedIsOpen: false,
    };
  },
  computed: {
    invalidName(){
      const name = ["option1", "option2"].includes(this.selectedType) ? this.extraVariable.name : this.dictionary.name
      return /[{|}:]/g.test(name) || this.extraVariables.some((v) => v.name == "{" + name + "}") 
    },
    valid() {
      if (this.selectedType == "option1")
        return this.extraVariable.name && this.extraVariable.expression && this.extraVariable.type;
      if (this.selectedType == "option2") {
        return (
          this.extraVariable.name &&
          this.extraVariable.type &&
          this.ifThen.ifThenList[0].ifCondition &&
          this.ifThen.ifThenList[0].then
        );
      }
      if (this.selectedType == "option3" || this.selectedType == "option4")
        return this.dictionary.name && this.dictionary.expression && this.mappings.length != 0;
      else return false;
    },
  },
  methods: {
    newIfInstance() {
      this.ifThen.ifThenList.push({
        ifCondition: "",
        then: "",
      });
    },
    removeIfInstance(index) {
      this.ifThen.ifThenList.splice(index, 1);
    },
    exportExtraVariable() {
      // this.extraVariable.name = "{extra-variables_" + this.extraVariable.name + '}'
      let extraVar;
      if (this.selectedType == "option1") {
        extraVar = {
          name: this.extraVariable.name,
          expression: this.extraVariable.expression,
          type: this.extraVariable.type,
        };
      }
      if (this.selectedType == "option2") {
        extraVar = {
          name: this.extraVariable.name,
          type: this.extraVariable.type,
          else: this.extraVariable.else,
          ifThenList: this.ifThen.ifThenList,
        };
      }
      if (this.selectedType == "option3" || this.selectedType == "option4") {
        let formattedMapping = {};
        this.mappings.forEach((mapping) => {
          formattedMapping[mapping.string] = mapping.expression;
        });
        extraVar = {
          name: this.dictionary.name,
          expression: this.dictionary.expression,
          mappings: formattedMapping,
          else: this.dictionary.expression,
          type: this.selectedType == "option3" ? "Text" : "List",
        };
      }
      if (this.selectedType == "option4") {
        extraVar.customVariableType = "ListDictionary";
      }
      extraVar.name = extraVar.name.replace(/[{}]/g, "");
      extraVar.referencedVariables = [
        ...new Set(
          (VariableHelpers.findInText(Object.entries(extraVar).join("")) || []).map((v) =>
            VariableHelpers.removeBrackets(v),
          ),
        ),
        "format",
      ];
      // check if name is a duplicate - only checks in other extraVariables, doesnt look for duplicates in all variables.
      if (!this.extraVariables.some((v) => v.name == "{" + extraVar.name + "}")) {
        extraVar.name = "{" + extraVar.name + "}";
        this.$emit("create-and-close");
        this.$store.state.template.extraVariables.push(extraVar);
        this.$store.state.unsavedChanges = true;
        this.createVariableClicked = false;
        this.extraVariable = false;
        this.selectedType = null;
        this.invalid = false;
      } else {
        this.invalid = true;
      }
    },
    addToExpression(variable) {
      if (this.selectedType == "option3" || this.selectedType == "option4") {
        this.dictionary[this.stagedInputField] = variable;
        this.stagedInputField = null;
      } else if (this.stagedInputField == "path") {
        this.variablePath = variable;
      } else if (typeof this.stagedInputField == "object") {
        this.ifThen.ifThenList[this.stagedInputField.index][this.stagedInputField.name] = variable;
        this.stagedInputField = null;
      } else {
        this.extraVariable[this.stagedInputField] = this.extraVariable[this.stagedInputField] + variable;
        this.stagedInputField = null;
      }
    },
    addMappingToMappings() {
      let mapEntry = {
        string: this.newMap.string,
        expression: this.newMap.expression,
      };
      this.mappings.push(mapEntry);
      this.newMap.string = "";
      this.newMap.expression = "";
    },
    removeMapping(mapping, index) {
      this.mappings.splice(index, 1);
      this.changesDetected = true;
    },
    unfocusInput() {
      this.stagedInputField = null;
    },
  },
  mounted() {
    EventBus.$on("add-to-expression", this.addToExpression);
    EventBus.$on("vars-closed", this.unfocusInput);
  },
  destroyed() {
    EventBus.$off("add-to-expression");
    EventBus.$off("vars-closed");
  },
   watch: {
      selectedType: {
      handler: function (val, oldVal) {
        if (oldVal == 'option3' || oldVal == 'option4'){
          this.$set(this.dictionary, 'expression', null)
        }
      },
    },
  },

  components: {
    CustomInput,
    DictionaryAdder,
  },
};
</script>

<style lang="less">
.variable-creator {
  position: relative;
  margin: 12px;
  margin-bottom: 42px;
  border-radius: var(--standard-border-radius);

  p {
    font-size: 18px;
    font-weight: bolder;
  }

  .extend-btn {
    border: none;
    background: inherit;
    color: var(--orange-web);
    font-size: 12px;
    cursor: pointer;
  }

  .actions {
    position: absolute;
    bottom: -50px;
    right: 12px;
    display: flex;
    justify-content: flex-end;
    .btn-primary {
      margin: 10px 0 0 0;
    }
  }
  .fold-out {
    animation: foldOut 0.4s ease;
  }
  .fold-in {
    animation: foldIn 0.2s ease;
  }
  @keyframes foldOut {
    from {
      transform: translateY(-30px);
      opacity: 0.6;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes foldIn {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateY(-30px);
      opacity: 0.6;
    }
  }

  .mappings {
    padding: 0 12px 12px 12px;
    button {
      z-index: 1;
      padding: 0;
      margin-top: 30px;
      padding-right: 10px;
    }
  }
  .arrow::after {
    content: "→";
    position: absolute;
    right: -8px;
    top: 40px;
  }

  .dictionary-group {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    button {
      height: 36px;
      width: max-content;
      &:hover {
        box-shadow: 5px 4px 4px 2px rgba(0, 0, 0, 0.25);
      }
    }
  }

  .radio-btns {
    // display: flex;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding-top: 12px;

    .container {
      display: block;
      position: relative;
      padding: 0;
      cursor: pointer;
      font-size: 22px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;

        &:checked ~ .check-indicator {
          background-color: var(--orange-web);
        }

        &:checked ~ .check-indicator:after {
          display: block;
        }
        &:checked ~ span {
          color: #495057;
        }
      }
      &:hover input ~ .check-indicator {
        filter: brightness(1.05);
      }

      .check-indicator {
        position: absolute;
        top: 0;
        left: 0;
        height: 18px;
        width: 18px;
        background-color: #e2e2e2;
        border-radius: 50%;

        &:after {
          content: "";
          position: absolute;
          display: none;
        }

        &:after {
          top: 6px;
          left: 6px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: white;
        }
      }

      span {
        margin-left: 24px;
      }
    }
  }
}
</style>
